export default __webpack_public_path__ + "179406400f46b6a6e374a2306e265051.svg";